/**
 * mega-menu.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.saipem_mega_menu = {
    attach: function (context, settings) {

      once('loadMegaMenu', 'ul.ultimenu--hover', context).forEach(
        function (element) {

            $(element).find('.nav-link').each(function(link){
              $(this).closest('.nav-item').find('ul').hide();
              $(this).mouseenter(function(e) {
                var level = $(this).data('level');
                $(this).closest('.nav').find('ul').hide();
                $(this).parents('ul').show();
                $(this).closest('.nav-item').children('ul').show();

                if(!$(this).hasClass('mouse-entered'))
                {
                    $(this).parents('ul').children('li').find('a').each(function(k){
                        if($(this).data('level')==level)
                        {
                            $(this).removeClass('mouse-entered');
                        }
                    });
                    $(this).addClass('mouse-entered');
                }

              });
            });

            $('ul.ultimenu--hover > .ultimenu__item.has-ultimenu > a').click(function(e){
              e.preventDefault();
              if($('header').hasClass('megamenu-white')){

                $('.ultimenu__flyout').removeClass('ultimenu__flyout__show');
                $(this).closest('li').find('.ultimenu__flyout').addClass('ultimenu__flyout__show');
                $('.ultimenu__link').removeClass('ultimenu__flyout__opened');
                $(this).addClass('ultimenu__flyout__opened');
              }
              else{
                $('header').addClass('megamenu-white');
                $('.ultimenu__flyout').removeClass('ultimenu__flyout__show');
                $(this).closest('li').find('.ultimenu__flyout').addClass('ultimenu__flyout__show');
                $('.ultimenu__link').removeClass('ultimenu__flyout__opened');
                $(this).addClass('ultimenu__flyout__opened');
              }
            });

            $('.megamenu-close-button').click(function(e){
              $('header').removeClass('megamenu-white');
              $('.ultimenu__flyout').removeClass('ultimenu__flyout__show');
              $('.ultimenu__link').removeClass('ultimenu__flyout__opened');
            });

            $('#ultimenu-header-navigation > .ultimenu__item > a').off('focus');


          $(".mb-nav-toggle").on('click', function(){
            if ($(this).hasClass('active')){
              $(this).removeClass('active');
              $(this).find('.fa-bars').show();
              $(this).find('.fa-xmark').hide();
              $('.mb-megamenu').hide();
              $('header').removeClass('menu-open');
            } else {
              $(this).find('.fa-bars').hide();
              $(this).find('.fa-xmark').show();
              $(this).addClass('active');
              $('.mb-megamenu').css("display","inline-block");
              $('header').addClass('menu-open');
            }

          });

        }
      );

    }

  };

  
  $('.intranet-top-header > a').click(function(e){
    e.preventDefault();
    ($(this).parents('.intranet-top-header')).toggleClass('active');
  });

  $('body').on('click', function(event) {
    if (!$(event.target).closest('.intranet-top-header').length) {
      $('.intranet-top-header').removeClass('active');
    }
  });


})(jQuery, Drupal, drupalSettings);
